module.exports = __webpack_public_path__ + "components/flag/static/square/mu-d172e3ae6d1b098075ff77c5f261e729.svg";